export default __webpack_public_path__ + "static/media/user-avatar.e20d8640.svg";